<!--
  - Copyright (c) 2023. Haodong JU
  -->

<script>

export default {
  name: 'ServiceCard',
  props: {
    oneTime: {},
    name: {},
    desc: {},
    price: {},
    checked: {},
    recommended: {}
  }
}
</script>

<template>
  <v-card
    class="pa-2 px-4 mb-3"
    color="grey lighten-3"
    elevation="0"
    @click="$emit('selectServe')"
  >
    <div
      :style="!$vuetify.breakpoint.mobile ? '' : 'width: 100%;'"
      class="d-flex align-center"
    >
      <div
        :class="!$vuetify.breakpoint.mobile ? 'mr-5' : ''"
        :style="!$vuetify.breakpoint.mobile ? 'width: fit-content;' : 'width: 50%;'"
      >
        <div class="text-body-1">
          {{ name }}
        </div>
        <div
          v-if="desc"
          class="text-body-2 mt-1 text--secondary"
        >
          {{ desc }}
        </div>
        <v-chip
          v-if="recommended"
          color="amber lighten-4 black--text"
          label
          x-small
        >
          {{ $t('MostSelectedProduct') }}
        </v-chip>
      </div>
      <v-spacer />
      <v-card
        :color="checked?'amber lighten-4 black--text':'grey lighten-3'"
        :style="!$vuetify.breakpoint.mobile ? '' : 'position: relative;'"
        class="d-block overflow-hidden text-body-2 pa-2 px-2"
        elevation="0"
      >
        <div
          :style="!$vuetify.breakpoint.mobile ? '' : 'position: relative;'"
          class="d-flex align-center"
        >
          <template v-if="oneTime !== 'one_time'">
            <div
              class="text-truncate"
              style="position: relative"
            >
              {{ $t('TheLowest') }}
            </div>
            <div
              class="ml-1 text-no-wrap"
              style="position: relative"
            >
              {{ price / 12 | priceDisplay }}
            </div>
            <div
              class="text-truncate"
              style="position: relative"
            >
              /{{ $t('Monthly') }}
            </div>
          </template>
          <template>
            <div
              class="text-no-wrap ml-1"
              style="position:relative;"
            >
              {{ price | priceDisplay }}
            </div>
          </template>
          <v-icon
            class="ml-1"
            small
          >
            {{ checked ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
          </v-icon>
        </div>
      </v-card>
    </div>
  </v-card>
</template>

<style scoped>

</style>
